import { Button, Grid, IconButton, Paper } from '@mui/material'
import { Box, Stack } from '@mui/system'
import React from 'react'
import BoxInput from '../../../../Components/BoxInput'
import SendIcon from "@mui/icons-material/Send";
import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-toastify';
import { useMutation } from '@tanstack/react-query';
import { contactForm } from '../../../../api/services';
import CloseIcon from "@mui/icons-material/Close";


const schema: yup.ObjectSchema<Omit<LeadData, 'type'>> = yup.object({
  name: yup.string().required('Name is required'),
  email: yup
    .string()
    .email('Invalid email format')
    .required('Email is required'),
  phoneNumber: yup
    .string()
    .matches(
      /^[6-9]\d{9}$/,
      'Phone number must start with 6, 7, 8, or 9 and be 10 digits',
    )
    .required('Phone number is required'),
  message: yup.string().optional(),
});
interface LeadData {
  name: string;
  email: string;
  phoneNumber: string;
  message?: string;
  type?: string;
}

interface Props {
  handleClose: () => void;
  pdfUrl?: string; // ✅ ADD THIS
}

const CoachingPopup: React.FC<Props> = ({ handleClose,pdfUrl  }) => {

      const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
      } = useForm<LeadData>({
        resolver: yupResolver(schema),
      });
    
      const mutation = useMutation({
        mutationFn: (newFormData: LeadData) => contactForm(newFormData),
        onSuccess: () => {
          toast.success('Successfully submitted!');
          resetForm();
        },
        onError: (error: any) => {
          toast.error(error?.response?.data?.message || 'Submission failed');
        },
      });
      const resetForm = () => {
        reset({
          name: '',
          email: '',
          phoneNumber: '',
          message: '',
        });
      };
    
      // const onSubmit = (data: LeadData) => {
      //   mutation.mutate({ ...data, type: 'coaching' });
      // };

      const onSubmit = (data: LeadData) => {
  mutation.mutate(
    { ...data, type: "coaching" },
    {
      onSuccess: () => {
        toast.success("Successfully submitted!");

        // ✅ SAFE DOWNLOAD (ONLY CURRENT PDF)
        if (pdfUrl) {
          setTimeout(() => {
            const link = document.createElement("a");
            link.href = pdfUrl;
            link.setAttribute("download", "program-details.pdf");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }, 300); // small delay ensures proper execution
        }

        resetForm();
        handleClose();
      },
    }
  );
};
  return (
    <Box
     sx={{
    p: { xs: 4, md: 6 },
    borderRadius: "28px",
    background: "transparent",
    position: "relative",
    color: "white",
  }}
    >
<IconButton
  onClick={handleClose}
  sx={{
    position: "absolute",
    top: 20,
    right: 20,
    color: "white",
    border: "1px solid rgba(255,255,255,0.2)",
    background: "rgba(255,255,255,0.05)",
    backdropFilter: "blur(10px)",
    "&:hover": {
      background: "rgba(26, 126, 192, 0.2)",
      borderColor: "#0f63a5",
    },
  }}
>
  <CloseIcon />
</IconButton>
        <form onSubmit={handleSubmit(onSubmit)}>

        <Grid item xs={12} md={6} mt={2}>
                    <Box
                    //   sx={{
                    //     p: 6,
                    //     borderRadius: "24px",
                    //     background: "#124e7847",
                    //     border: "1px solid rgba(255,255,255,0.2)",
                    //     backdropFilter: "blur(20px)",
                    //     boxShadow: "0 30px 80px rgba(0,0,0,0.4)",
                    //   }}
                    >
                      <Stack spacing={2}>
                        <Controller
                          name="name"
                          control={control}
                          render={({ field }) => (
                            <>
                              {/* <Typography
                                sx={{
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  mb: 1,
                                  color: "#333",
                                }}
                              >
                                Full Name
                              </Typography> */}
        
                              <BoxInput
                                placeholder="Enter your full name"
                                {...field}   // ✅ VERY IMPORTANT
                                error={!!errors.name}
                                helperText={errors.name?.message}
                              />
                            </>
                          )}
                        />
        
                        <Grid item xs={12}>
                          <Controller
                            name="email"
                            control={control}
                            render={({ field }) => (
                              <BoxInput
                                placeholder="Enter your Email"
                                {...field}
                                error={!!errors.email}
                                helperText={errors.email?.message}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Controller
                            name="phoneNumber"
                            control={control}
                            render={({ field }) => (
                              <BoxInput
                                placeholder="Enter your Phone Number"
                                {...field}
                                error={!!errors.phoneNumber}
                                helperText={errors.phoneNumber?.message}
                              />
                            )}
                          />
                        </Grid>
        
                        <Grid item xs={12}>
                          <Controller
                            name="message"
                            control={control}
                            render={({ field }) => (
                              <BoxInput
        
                                placeholder="Write your message here..."
                                multiline
                                rows={3}
                                {...field}
        
                              />
                            )}
                          />
                        </Grid>
        
                        <Button
                          type="submit"
                          variant="contained"
                          endIcon={<SendIcon />}
                          sx={{
                            py: 1.6,
                            fontWeight: 700,
                            borderRadius: "12px",
                            background:
                              "linear-gradient(135deg, #0f63a5, #0c4e82)",
                            boxShadow:
                              "0 15px 40px rgba(15,99,165,0.35)",
                            "&:hover": {
                              background:
                                "linear-gradient(135deg, #0c4e82, #083b63)",
                            },
                          }}
                        >
                          Send Message
                        </Button>
                      </Stack>
                    </Box>
                  </Grid>
        </form>
    </Box>
  )
}

export default CoachingPopup